import type { DecorationAssetFragment } from '@seek/cmsu-cms-connect';

import { useScreenSize } from '../../../hooks/useScreenSize';

export const useGetDecoratorAssetConfig = ({
  decorator,
}: {
  decorator: DecorationAssetFragment;
}) => {
  const { isMobile, isTablet } = useScreenSize();

  if (isMobile && decorator?.mobileScreenConfig) {
    return decorator.mobileScreenConfig;
  }
  if (isTablet && decorator?.tabletScreenConfig) {
    return decorator.tabletScreenConfig;
  }
  return decorator?.desktopScreenConfig;
};
